import { Box } from '@mantine/core';
import UploadFiles from 'components/files/upload/UploadFiles';

/**
 * Page used to test various components.
 */
export default function TestPage() {
  return (
    <Box p={24}>
      <UploadFiles />
    </Box>
  );
}
